import { render, staticRenderFns } from "./BusClsClmResCat.vue?vue&type=template&id=48ec0401&"
import script from "./BusClsClmResCat.vue?vue&type=script&lang=js&"
export * from "./BusClsClmResCat.vue?vue&type=script&lang=js&"
import style0 from "./BusClsClmResCat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusClsClmResCat.vue"
export default component.exports